import { createFileRoute, useNavigate, redirect } from '@tanstack/react-router';
import { RosterStep } from '../features/rsvp/steps/RosterStep';
import { PageShell } from '../features/rsvp/PageShell';
import { useRsvpFlow } from '../features/rsvp/useRsvpFlow';

export const Route = createFileRoute('/rsvp/roster')({
  beforeLoad: async () => {
    throw redirect({ to: '/' });
  },
  component: RosterPage,
});

function RosterPage() {
  const navigate = useNavigate();
  const f = useRsvpFlow();

  if (f.children.length === 0 && !f.draft.child_name) return null;

  return (
    <PageShell globalError={f.globalError}>
      <RosterStep
        parent={f.parent}
        draftChildren={f.children}
        characterById={f.characterById}
        onAddAnother={() => {
          f.resetDraft();
          navigate({ to: '/rsvp/child' });
        }}
        onSubmit={f.submitAll}
        submitting={f.submitting}
        onFixChild={(draftId) => {
          f.editChild(draftId);
          navigate({ to: '/rsvp/child' });
        }}
      />
    </PageShell>
  );
}
